import { DIGISAKA_API_ORIGIN } from '../../../config/digisakaApiOrigin';
import { CROP_AREA_COLOR, CROP_AREA_COLOR_RGBA } from './cropAreaColor';

/** Philippines sugarcane area. Classes 1 and 2 are sugarcane; empty pixels stay hidden. */
export const SUGARCANE_CROP_COG_URL =
  'https://digisaka.s3.amazonaws.com/crop_area/philippines_sugarcane_area_2021_native_cog.tif';

/** Raster extent from TiTiler /info (EPSG:4326). */
export const SUGARCANE_CROP_BBOX: [number, number, number, number] = [
  116.9315, 4.6134, 126.6015, 21.1206,
];

const TITILER_TILE_BASE = DIGISAKA_API_ORIGIN + '/api/tiles/WebMercatorQuad/{z}/{x}/{y}@2x.png';

export const SUGARCANE_CROP_COLOR = CROP_AREA_COLOR;

/** Values from 0.5 through 3 are sugarcane. Empty and near-zero pixels stay hidden. */
const SUGARCANE_CROP_COLORMAP = [[[0.5, 3], CROP_AREA_COLOR_RGBA]];

export const SUGARCANE_CROP_LEGEND = {
  colors: [SUGARCANE_CROP_COLOR],
  labels: ['Sugarcane'],
  description: 'Sugarcane areas',
};

/**
 * The COG was re-exported (uint8, 100 m, overviews with data). TiTiler had cached the old
 * file's header for the plain URL, which caused 500 errors. S3 ignores the query string, so
 * bump this value whenever the file is replaced to force a fresh read.
 */
const SUGARCANE_CROP_COG_VERSION = '20261015';

export function buildSugarcaneCropTileUrl(cogUrl: string = SUGARCANE_CROP_COG_URL): string {
  const params = new URLSearchParams();
  params.set('url', `${cogUrl}?v=${SUGARCANE_CROP_COG_VERSION}`);
  params.set('bidx', '1');
  params.set('colormap', JSON.stringify(SUGARCANE_CROP_COLORMAP));
  params.set('resampling', 'mode');
  return `${TITILER_TILE_BASE}?${params.toString()}`;
}
